import {createGlobalStyle} from "styled-components";
import {APP_ROOT_ELEMENT_ID} from "../application/application.service.interface";


export const GlobalStyles = createGlobalStyle`
    #${APP_ROOT_ELEMENT_ID} * {
        box-sizing: border-box;
        font-family: var(--ion-font-family);
        line-height: 1;
    }

    #${APP_ROOT_ELEMENT_ID} {
        color: ${props => props.theme.colors.dark};
    }
`
